export class UserExportModel {
    public pageViewId: string = '';
    public chartName: string | undefined = undefined;
    public exportType: string = '';
}

export class UserExportResponseModel {
    public userExportId: string = '';
}